import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { usersApi } from '@/services/api/users'
import { CreateMemberUserInput } from '@/types/admin'

export function useUsers() {
  return useQuery({
    queryKey: ['admin', 'users'],
    queryFn: usersApi.list,
  })
}

export function useUserSuggestions(username: string | undefined) {
  return useQuery({
    queryKey: ['admin', 'users', username, 'suggestions'],
    queryFn: () => usersApi.getSuggestions(username!),
    enabled: !!username, // Only run query if username is provided
  })
}

export function useCreateUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateMemberUserInput) => usersApi.create(data),
    onSuccess: () => {
      // Invalidate and refetch users list
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] })
    },
  })
}

export function useDeleteUser() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (username: string) => usersApi.delete(username),
    onSuccess: () => {
      // Invalidate and refetch users list
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] })
    },
  })
}

export function useResendWelcomeEmail() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (username: string) => usersApi.resendWelcomeEmail(username),
    onSuccess: () => {
      // Invalidate and refetch users list to update any status changes
      queryClient.invalidateQueries({ queryKey: ['admin', 'users'] })
    },
  })
}
